
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_1u1y1_94",
  "trigger": "awsui_trigger_14cnr_1u1y1_107",
  "dropdown": "awsui_dropdown_14cnr_1u1y1_110",
  "nowrap": "awsui_nowrap_14cnr_1u1y1_121",
  "open": "awsui_open_14cnr_1u1y1_124"
};
  